module.exports = __webpack_public_path__ + "static/zoho-ff5295b0ed1c3f8f8272d6ef26336e54.png";